module.exports = {
	"config": {
		"blogTitle": "Your Title Here",
		"subTitle": "your subtitle here",
		"blogUrl": "http://whatever.com",
		"authorName": "David Konsumer",
		"authorBio": "Written by <strong>David Konsumer</strong> who lives and works in Portland and makes rad stuff. You should follow him on <a href='https://twitter.com/davidkonsumer'>Twitter</a> &amp; <a href='https://github.com/konsumer'>Github</a>",
		"linkPrefix": "/gatsby-starter-drunkenblog"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js",
				"absolute": "/Users/konsumer/Projects/gatsby-starter-drunkenblog/_template.js",
				"isAbsolute": false
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "2015-05-01-hello-world",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2015-05-01-hello-world",
				"stem": "index",
				"path": "2015-05-01-hello-world/index.md",
				"absolute": "/Users/konsumer/Projects/gatsby-starter-drunkenblog/2015-05-01-hello-world/index.md",
				"isAbsolute": false
			},
			"requirePath": "2015-05-01-hello-world/index.md",
			"path": "/hello-world/",
			"data": {
				"title": "Hello World",
				"date": "2015-05-01T22:12:03.284Z",
				"layout": "post",
				"readNext": "/my-second-post/",
				"path": "/hello-world/",
				"tags": [
					"Hello",
					"world",
					"demo"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2015-05-06-my-second-post",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2015-05-06-my-second-post",
				"stem": "index",
				"path": "2015-05-06-my-second-post/index.md",
				"absolute": "/Users/konsumer/Projects/gatsby-starter-drunkenblog/2015-05-06-my-second-post/index.md",
				"isAbsolute": false
			},
			"requirePath": "2015-05-06-my-second-post/index.md",
			"path": "/my-second-post/",
			"data": {
				"title": "My Second Post!",
				"date": "2015-05-06T23:46:37.121Z",
				"layout": "post",
				"readNext": "/hi-folks/",
				"path": "/my-second-post/",
				"tags": [
					"demo"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "2015-05-28-hi-folks",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "2015-05-28-hi-folks",
				"stem": "index",
				"path": "2015-05-28-hi-folks/index.md",
				"absolute": "/Users/konsumer/Projects/gatsby-starter-drunkenblog/2015-05-28-hi-folks/index.md",
				"isAbsolute": false
			},
			"requirePath": "2015-05-28-hi-folks/index.md",
			"path": "/hi-folks/",
			"data": {
				"title": "New Beginnings",
				"date": "2015-05-28T22:40:32.169Z",
				"layout": "post",
				"path": "/hi-folks/",
				"tags": [
					"demo"
				]
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/konsumer/Projects/gatsby-starter-drunkenblog/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/konsumer/Projects/gatsby-starter-drunkenblog/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "tags",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "tags",
				"stem": "index",
				"path": "tags/index.js",
				"absolute": "/Users/konsumer/Projects/gatsby-starter-drunkenblog/tags/index.js",
				"isAbsolute": false
			},
			"requirePath": "tags/index.js",
			"path": "/tags/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 363
 ** module chunks = 0
 **/